import React from "react";

const PoolChanOutline = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="304.87"
      height="575.195"
      fillRule="nonzero"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      clipRule="evenodd"
      version="1.1"
      viewBox="0 0 304.87 575.195"
      xmlSpace="preserve"
      className="clickable"
    >
      <g
        fill="rgba(0,0,0,0)"
        className="object-glow"
        stroke="#ff5c97"
        strokeLinejoin="round"
        transform="translate(-2073.305 -583.559)"
      >
        <path
          strokeLinecap="round"
          strokeWidth="5"
          d="M2236.5 606.2c-.47.933-3.03 1.867-7.7 2.8-4.67.933-9.33 4.667-14 11.2-4.67 6.533-8.17 15.167-10.5 25.9-2.33 10.733-3.03 19.833-2.1 27.3.93 7.467-1.87 12.367-8.4 14.7-6.53 2.333-10.03 4.2-10.5 5.6-.47 1.4-3.27 3.5-8.4 6.3-5.13 2.8-9.33 6.3-12.6 10.5-3.27 4.2-5.6 9.8-7 16.8-1.4 7-1.4 19.367 0 37.1s.47 34.3-2.8 49.7c-3.27 15.4-4.9 32.2-4.9 50.4 0 18.2-1.17 28.7-3.5 31.5-2.33 2.8-3.5 5.133-3.5 7s-5.37 3.5-16.1 4.9c-10.73 1.4-18.67 3.033-23.8 4.9-5.13 1.867-7.93 3.5-8.4 4.9-.23.7-.47 1.4-.7 2.1h30.8c20.53 0 31.27-.467 32.2-1.4.93-.933 2.33-1.167 4.2-.7 1.87.467 3.27-.7 4.2-3.5.93-2.8 2.1-4.2 3.5-4.2s3.5 1.4 6.3 4.2c2.8 2.8 9.57 4.2 20.3 4.2s17.5 5.133 20.3 15.4c2.8 10.267 4.9 25.9 6.3 46.9 1.4 21 3.5 38.97 6.3 53.9s3.27 26.83 1.4 35.7c-1.87 8.87-2.57 14.23-2.1 16.1.47 1.87 1.63 3.03 3.5 3.5 1.87.47 2.1 4.43.7 11.9-1.4 7.47-3.5 13.3-6.3 17.5-2.8 4.2-4.43 7.93-4.9 11.2-.47 3.27.23 5.6 2.1 7 1.87 1.4 7 2.57 15.4 3.5 8.4.93 13.53-.23 15.4-3.5 1.87-3.27 3.27-7.7 4.2-13.3.93-5.6 1.17-12.13.7-19.6-.47-7.47.7-12.13 3.5-14 2.8-1.87 3.73-4.2 2.8-7-.93-2.8-.93-18.43 0-46.9s1.87-42.7 2.8-42.7c.93 0 2.1 3.967 3.5 11.9 1.4 7.93 3.27 12.13 5.6 12.6 2.33.47 3.27 3.5 2.8 9.1-.47 5.6.7 9.8 3.5 12.6 2.8 2.8 6.3 8.4 10.5 16.8s9.57 12.37 16.1 11.9c6.53-.47 12.37-1.87 17.5-4.2 5.13-2.33 7.7-4.43 7.7-6.3s-2.8-5.37-8.4-10.5c-5.6-5.13-10.03-10.97-13.3-17.5-3.27-6.53-7-21.7-11.2-45.5-4.2-23.8-6.77-42-7.7-54.6-.93-12.6-.93-19.133 0-19.6.47-.233.93-.467 1.4-.7.47 1.167.93 2.333 1.4 3.5.93 2.333 2.33 3.967 4.2 4.9 1.87.933 12.37 1.4 31.5 1.4h28.7v-1.4c0-.933-2.57-2.8-7.7-5.6-5.13-2.8-10.73-3.967-16.8-3.5-6.07.467-12.37-.467-18.9-2.8-6.53-2.333-10.27-7.933-11.2-16.8-.93-8.867-1.4-16.1-1.4-21.7 0-5.6.47-9.1 1.4-10.5.93-1.4.93-16.333 0-44.8s-.47-46.667 1.4-54.6c1.87-7.933 2.8-15.167 2.8-21.7 0-6.533 1.37-5.889.67-11.839-.7-5.95-1.6-4.494-3.47-11.961-1.87-7.467-5.13-12.367-9.8-14.7-4.67-2.333-7.93-7.233-9.8-14.7-1.87-7.467-2.8-14.7-2.8-21.7s-2.33-15.867-7-26.6-9.57-17.967-14.7-21.7c-5.13-3.733-10.5-6.067-16.1-7-5.6-.933-8.63-.933-9.1 0z"
          opacity="1"
        ></path>
        <path
          strokeLinecap="butt"
          strokeWidth="2"
          d="M2270.91 819.126l2.75-.274.01 8.595s-2-.691-2.69-2.771c-.69-2.081-.07-5.55-.07-5.55z"
          opacity="1"
        ></path>
      </g>
    </svg>
  );
}

export default PoolChanOutline;
